export default __webpack_public_path__ + "static/media/icon-relacao-receita-a.b4fc23df.svg";